import {Component, Input} from '@angular/core';
import {UserDownloadInfo, ProductOffering} from '@uofu-uss-aux/software-catalog-ng-core';
import {KnownPlatform, PlatformService} from '../../product/platform.service';
import {NgForOf, NgIf} from '@angular/common';
import {PlatformIconComponent} from '../../svg/platform-icon/platform-icon.component';
import {DownloadComponent} from '../../download/download/download.component';

@Component({
  selector: 'app-download-without-purchase-item',
  templateUrl: './download-without-purchase-item.component.html',
  styleUrls: ['./download-without-purchase-item.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    PlatformIconComponent,
    DownloadComponent,
    NgForOf
  ]
})
export class DownloadWithoutPurchaseItemComponent {
  @Input()
  downloads: ReadonlyArray<UserDownloadInfo>;
  platformName = '';
  platform = KnownPlatform.web;

  private _offering: ProductOffering;


  constructor(private readonly platformService: PlatformService) { }

  get offering() {
    return this._offering;
  }

  @Input()
  set offering(given: ProductOffering) {
    this._offering = given;
    this.platform = this.platformService.findPlatform(given?.platform);
    this.platformName = given?.platform?.title || '';
  }

}
